import { render, staticRenderFns } from "./VerCrearModal.vue?vue&type=template&id=517b3ed1&"
import script from "./VerCrearModal.vue?vue&type=script&lang=ts&"
export * from "./VerCrearModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports